import { PropTypes } from 'prop-types';
import styles from './styles.module.scss';

const Legend = ({ children }) => (<p className={styles.legend}>
  {children}
</p>);

Legend.propTypes = {
  children: PropTypes.node
};

export default Legend;
